var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgencySearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M51.25 52.5C65.7475 52.5 77.5 40.7475 77.5 26.25C77.5 11.7525 65.7475 0 51.25 0C36.7525 0 25 11.7525 25 26.25C25 40.7475 36.7525 52.5 51.25 52.5Z",
    fill: "#E53B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 80V71.25C23.75 58.75 32.5 60 41.25 55",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.25 55C70 60 78.75 58.75 78.75 71.25V80",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 60L51.25 57.5L46.25 60L41.25 55L43.75 51.25L51.25 52.5L58.75 51.25L61.25 55L56.25 60Z",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 46.25V51.25",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51.25V46.25",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68.75H52.5",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63.75H52.5",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 30C62.5 22.4063 58.8437 18.75 51.25 18.75C43.6563 18.75 40 22.4063 40 30V35C41.25 43.75 45 46.25 45 46.25C47.5 47.5 51.25 47.5 51.25 47.5C51.25 47.5 55 47.5 57.5 46.25C57.5 46.25 61.25 43.75 62.5 35V30Z",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30L45 27.5L51.25 30L57.5 32.5L62.5 30",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 80V72.5",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.75 80V72.5",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.005 52.5544H4.44495V6.04688H38.895V14.7169",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75128 40.4955H15.6413",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75128 43.9419H20.8088",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75128 47.3883H29.4213",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3637 40.4955H29.4212",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5314 43.9419H29.4214",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2825 56.0005H1V8.63165",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9188 32.7454C13.9188 27.5779 19.0863 25.8554 19.0863 25.8554",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4214 32.7454C29.4214 27.5779 24.2539 25.8554 24.2539 25.8554",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9762 21.1185C25.9762 24.1329 24.2856 26.7167 21.67 26.7167C19.0543 26.7167 17.3637 24.1329 17.3637 21.1185C17.3637 18.1042 18.225 16.3817 21.67 16.3817C25.115 16.3817 25.9762 18.1042 25.9762 21.1185Z",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6699 35.3279C28.3291 35.3279 33.7275 29.9296 33.7275 23.2704C33.7275 16.6112 28.3291 11.2129 21.6699 11.2129C15.0108 11.2129 9.61243 16.6112 9.61243 23.2704C9.61243 29.9296 15.0108 35.3279 21.6699 35.3279Z",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencySearchIcon);
export default __webpack_public_path__ + "static/media/agency-search-icon.c95e77a39c73c7466f244cf82ae9a293.svg";
export { ForwardRef as ReactComponent };